
import { Mapper } from "../../../../base/utils/mapper";
import { PlanePostureNeurologyModel } from "../../../../domain/models/consult/plane-posture-neurology.model";
import { PlanePostureNeurologyEntity } from "../entities/plane-posture-neurology.entity";
        export class PlanePostureNeurologyImplementationRepositoryRepositoryMapper extends Mapper<PlanePostureNeurologyEntity, PlanePostureNeurologyModel>{
            mapFrom(param:  PlanePostureNeurologyEntity):  PlanePostureNeurologyModel { 
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors
                }; 
            }
            mapTo(param:  PlanePostureNeurologyModel):  PlanePostureNeurologyEntity {
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors 
                };
            }
        }